import React, { useState } from 'react';
import { BiPencil } from 'react-icons/bi';

interface EditableNumberCellProps {
    value?: number;
    onSave: (newValue: number) => void;
}

export const EditableNumberCell: React.FC<EditableNumberCellProps> = ({ value = 0, onSave }) => {
    const [editing, setEditing] = useState(false);
    const [editValue, setEditValue] = useState(value);

    const handleBlurOrEnter = () => {
        onSave(editValue);
        setEditing(false);
    };

    return (
        <td className="text-right cursor-pointer text-nowrap" onClick={() => !editing && setEditing(true)}>
            {editing ? (
                <input
                    type="number"
                    value={editValue}
                    onChange={ev => {
                        const val = ev.target.value.replace(',', '');
                        const parsed = parseInt(val, 10);
                        if (!isNaN(parsed)) setEditValue(parsed);
                    }}
                    onBlur={handleBlurOrEnter}
                    onKeyDown={ev => {
                        if (ev.key === 'Enter') handleBlurOrEnter();
                        if (ev.key === 'Escape') setEditing(false);
                        if (ev.key === '.' || ev.key === ',') ev.preventDefault();
                    }}
                    autoFocus
                    style={{ width: '80px', textAlign: 'right' }}
                    step={1}
                    min={0}
                />
            ) : (
                <>
                    <BiPencil />
                    {value} €
                </>
            )}
        </td>
    );
};
